import { Button, ButtonProps, PolymorphicComponentProps } from "@mantine/core";

export function MButton(
  props: PolymorphicComponentProps<"button", ButtonProps>,
) {
  return (
    <Button
      classNames={{
        label:
          "text-primaryBlack dark:text-white leading-10 text-3xl font-medium",
      }}
      {...props}
    />
  );
}
